import { MutationTree } from 'vuex';

export const state = () => ({
  id: null,
  query: {
    where: {},
    sort: {
      createdAt: 'DESC',
      active: 'DESC',
      order: 'ASC'
    },
    offset: 0,
    limit: 10
  },
  table: {
    footer: {
      'items-per-page-options': [10, 25, 50, 100],
      'show-current-page': true,
      'show-first-last-page': true,
      'page-text': '{{pageStart}}',
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      }
    },
    filter: {
      id: null
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['createdAt', 'order', 'active'],
      sortDesc: [true, false, true],
      groupBy: [],
      groupDesc: [],
      multiSort: true,
      mustSort: true,
      pageStart: 0,
      pageStop: 0
    }
  }
});

export type BannerState = ReturnType<typeof state>;

export const mutations: MutationTree<BannerState> = {
  changeId: (state, id) => (state.id = id),
  changeQuery: (state, query) => Object.assign(state.query, query),
  changeTableFilter: (state, filter) => {
    Object.assign(state.table, { filter });
    Object.assign(state.query.where, {
      id: filter.id
    });
  },
  changeTableOptions: (state, options) => {
    Object.assign(state.table, { options });
    Object.assign(state.table.footer, { options });
    Object.assign(state.query, {
      sort: {
        [options.sortBy[0]]: options.sortDesc[0] ? 'DESC' : 'ASC',
        [options.sortBy[1]]: options.sortDesc[1] ? 'DESC' : 'ASC',
        [options.sortBy[2]]: options.sortDesc[2] ? 'DESC' : 'ASC'
      },
      limit: options.itemsPerPage,
      offset: (options.page - 1) * options.itemsPerPage
    });
  }
};
